var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/arrow_forward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7834 8.66674H3.33341C3.14453 8.66674 2.98619 8.60285 2.85841 8.47507C2.73064 8.3473 2.66675 8.18896 2.66675 8.00007C2.66675 7.81118 2.73064 7.65285 2.85841 7.52507C2.98619 7.3973 3.14453 7.33341 3.33341 7.33341H10.7834L7.51675 4.06674C7.38341 3.93341 7.31953 3.77785 7.32508 3.60007C7.33064 3.4223 7.40008 3.26674 7.53341 3.13341C7.66675 3.01118 7.8223 2.9473 8.00008 2.94174C8.17786 2.93618 8.33341 3.00007 8.46675 3.13341L12.8667 7.53341C12.9334 7.60007 12.9806 7.6723 13.0084 7.75007C13.0362 7.82785 13.0501 7.91118 13.0501 8.00007C13.0501 8.08896 13.0362 8.1723 13.0084 8.25007C12.9806 8.32785 12.9334 8.40007 12.8667 8.46674L8.46675 12.8667C8.34453 12.989 8.19175 13.0501 8.00841 13.0501C7.82508 13.0501 7.66675 12.989 7.53341 12.8667C7.40008 12.7334 7.33341 12.5751 7.33341 12.3917C7.33341 12.2084 7.40008 12.0501 7.53341 11.9167L10.7834 8.66674Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow_forward.27a381e8b19bea1ddd107811ad4c52d5.svg";
export { ForwardRef as ReactComponent };